import { render } from "./introView.vue?vue&type=template&id=0a0189fa"
import script from "./introView.vue?vue&type=script&lang=js"
export * from "./introView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__